// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BufferSnapshot, BufferSnapshotT, verifyBufferSnapshot } from "./buffer-snapshot";
import {
  ConnectionSnapshot,
  ConnectionSnapshotT,
  verifyConnectionSnapshot,
} from "./connection-snapshot";
import { DebounceSnapshot, DebounceSnapshotT, verifyDebounceSnapshot } from "./debounce-snapshot";
import { FrontendSnapshot, FrontendSnapshotT, verifyFrontendSnapshot } from "./frontend-snapshot";
import {
  MessageFingerprint,
  MessageFingerprintT,
  verifyMessageFingerprint,
} from "./message-fingerprint";
import { NyctSnapshot, NyctSnapshotT, verifyNyctSnapshot } from "./nyct-snapshot";
import { QuestDbSnapshot, QuestDbSnapshotT, verifyQuestDbSnapshot } from "./quest-db-snapshot";
import {
  RecordMapSnapshot,
  RecordMapSnapshotT,
  verifyRecordMapSnapshot,
} from "./record-map-snapshot";
import { SourceComponent } from "./source-component";
import { StateSnapshot, StateSnapshotT, verifyStateSnapshot } from "./state-snapshot";
import { TraceKV, TraceKVT, verifyTraceKV } from "./trace-kv";
import { TraceOutcome } from "./trace-outcome";
import { TracePath } from "./trace-path";
import { TracePointId } from "./trace-point-id";
import { U128, U128T, verifyU128 } from "../u128/u128";

/**
 * A single trace event — the core unit of instrumentation.
 */
export class TraceEvent implements flatbuffers.IUnpackableObject<TraceEventT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TraceEvent {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTraceEvent(bb: flatbuffers.ByteBuffer, obj?: TraceEvent): TraceEvent {
    return (obj || new TraceEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTraceEvent(bb: flatbuffers.ByteBuffer, obj?: TraceEvent): TraceEvent {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TraceEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  correlationId(obj?: U128): U128 | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new U128()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  sequenceNumber(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  tracePoint(): TracePointId {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : TracePointId.WvsListenerBound;
  }

  timestampNs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  outcome(): TraceOutcome {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TraceOutcome.Ok;
  }

  path(): TracePath {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TracePath.Forward;
  }

  source(): SourceComponent {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SourceComponent.Wvs;
  }

  bankId(obj?: U128): U128 | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new U128()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  liftId(obj?: U128): U128 | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new U128()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fingerprint(obj?: MessageFingerprint): MessageFingerprint | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new MessageFingerprint()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  state(obj?: StateSnapshot): StateSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new StateSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  debounce(obj?: DebounceSnapshot): DebounceSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new DebounceSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  buffer(obj?: BufferSnapshot): BufferSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new BufferSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  connection(obj?: ConnectionSnapshot): ConnectionSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new ConnectionSnapshot()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  recordMap(obj?: RecordMapSnapshot): RecordMapSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new RecordMapSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  questdb(obj?: QuestDbSnapshot): QuestDbSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? (obj || new QuestDbSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  frontend(obj?: FrontendSnapshot): FrontendSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new FrontendSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  nyct(obj?: NyctSnapshot): NyctSnapshot | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new NyctSnapshot()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  payloadSample(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  payloadSampleLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  payloadSampleArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  extra(index: number, obj?: TraceKV): TraceKV | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new TraceKV()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  extraLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  errorMessage(): string | null;
  errorMessage(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  errorMessage(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startTraceEvent(builder: flatbuffers.Builder) {
    builder.startObject(21);
  }

  static addCorrelationId(builder: flatbuffers.Builder, correlationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, correlationIdOffset, 0);
  }

  static addSequenceNumber(builder: flatbuffers.Builder, sequenceNumber: bigint) {
    builder.addFieldInt64(1, sequenceNumber, 0n);
  }

  static addTracePoint(builder: flatbuffers.Builder, tracePoint: TracePointId) {
    builder.addFieldInt16(2, tracePoint, TracePointId.WvsListenerBound);
  }

  static addTimestampNs(builder: flatbuffers.Builder, timestampNs: bigint) {
    builder.addFieldInt64(3, timestampNs, 0n);
  }

  static addOutcome(builder: flatbuffers.Builder, outcome: TraceOutcome) {
    builder.addFieldInt8(4, outcome, TraceOutcome.Ok);
  }

  static addPath(builder: flatbuffers.Builder, path: TracePath) {
    builder.addFieldInt8(5, path, TracePath.Forward);
  }

  static addSource(builder: flatbuffers.Builder, source: SourceComponent) {
    builder.addFieldInt8(6, source, SourceComponent.Wvs);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, bankIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, liftIdOffset, 0);
  }

  static addFingerprint(builder: flatbuffers.Builder, fingerprintOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, fingerprintOffset, 0);
  }

  static addState(builder: flatbuffers.Builder, stateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, stateOffset, 0);
  }

  static addDebounce(builder: flatbuffers.Builder, debounceOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, debounceOffset, 0);
  }

  static addBuffer(builder: flatbuffers.Builder, bufferOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, bufferOffset, 0);
  }

  static addConnection(builder: flatbuffers.Builder, connectionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, connectionOffset, 0);
  }

  static addRecordMap(builder: flatbuffers.Builder, recordMapOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, recordMapOffset, 0);
  }

  static addQuestdb(builder: flatbuffers.Builder, questdbOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, questdbOffset, 0);
  }

  static addFrontend(builder: flatbuffers.Builder, frontendOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, frontendOffset, 0);
  }

  static addNyct(builder: flatbuffers.Builder, nyctOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, nyctOffset, 0);
  }

  static addPayloadSample(builder: flatbuffers.Builder, payloadSampleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, payloadSampleOffset, 0);
  }

  static createPayloadSampleVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startPayloadSampleVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addExtra(builder: flatbuffers.Builder, extraOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, extraOffset, 0);
  }

  static createExtraVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startExtraVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addErrorMessage(builder: flatbuffers.Builder, errorMessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, errorMessageOffset, 0);
  }

  static endTraceEvent(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): TraceEventT {
    return new TraceEventT(
      this.correlationId() !== null ? this.correlationId()!.unpack() : null,
      this.sequenceNumber(),
      this.tracePoint(),
      this.timestampNs(),
      this.outcome(),
      this.path(),
      this.source(),
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.fingerprint() !== null ? this.fingerprint()!.unpack() : null,
      this.state() !== null ? this.state()!.unpack() : null,
      this.debounce() !== null ? this.debounce()!.unpack() : null,
      this.buffer() !== null ? this.buffer()!.unpack() : null,
      this.connection() !== null ? this.connection()!.unpack() : null,
      this.recordMap() !== null ? this.recordMap()!.unpack() : null,
      this.questdb() !== null ? this.questdb()!.unpack() : null,
      this.frontend() !== null ? this.frontend()!.unpack() : null,
      this.nyct() !== null ? this.nyct()!.unpack() : null,
      this.bb!.createScalarList<number>(this.payloadSample.bind(this), this.payloadSampleLength()),
      this.bb!.createObjList<TraceKV, TraceKVT>(this.extra.bind(this), this.extraLength()),
      this.errorMessage(),
    );
  }

  unpackTo(_o: TraceEventT): void {
    _o.correlationId = this.correlationId() !== null ? this.correlationId()!.unpack() : null;
    _o.sequenceNumber = this.sequenceNumber();
    _o.tracePoint = this.tracePoint();
    _o.timestampNs = this.timestampNs();
    _o.outcome = this.outcome();
    _o.path = this.path();
    _o.source = this.source();
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.fingerprint = this.fingerprint() !== null ? this.fingerprint()!.unpack() : null;
    _o.state = this.state() !== null ? this.state()!.unpack() : null;
    _o.debounce = this.debounce() !== null ? this.debounce()!.unpack() : null;
    _o.buffer = this.buffer() !== null ? this.buffer()!.unpack() : null;
    _o.connection = this.connection() !== null ? this.connection()!.unpack() : null;
    _o.recordMap = this.recordMap() !== null ? this.recordMap()!.unpack() : null;
    _o.questdb = this.questdb() !== null ? this.questdb()!.unpack() : null;
    _o.frontend = this.frontend() !== null ? this.frontend()!.unpack() : null;
    _o.nyct = this.nyct() !== null ? this.nyct()!.unpack() : null;
    _o.payloadSample = this.bb!.createScalarList<number>(
      this.payloadSample.bind(this),
      this.payloadSampleLength(),
    );
    _o.extra = this.bb!.createObjList<TraceKV, TraceKVT>(this.extra.bind(this), this.extraLength());
    _o.errorMessage = this.errorMessage();
  }

  unpackFields(...fields: string[]): TraceEventT {
    const t = new TraceEventT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("correlation_id")) {
      t.correlationId = this.correlationId() !== null ? this.correlationId()!.unpack() : null;
    }
    if (fieldSet.has("sequence_number")) {
      t.sequenceNumber = this.sequenceNumber();
    }
    if (fieldSet.has("trace_point")) {
      t.tracePoint = this.tracePoint();
    }
    if (fieldSet.has("timestamp_ns")) {
      t.timestampNs = this.timestampNs();
    }
    if (fieldSet.has("outcome")) {
      t.outcome = this.outcome();
    }
    if (fieldSet.has("path")) {
      t.path = this.path();
    }
    if (fieldSet.has("source")) {
      t.source = this.source();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("fingerprint")) {
      t.fingerprint = this.fingerprint() !== null ? this.fingerprint()!.unpack() : null;
    }
    if (fieldSet.has("state")) {
      t.state = this.state() !== null ? this.state()!.unpack() : null;
    }
    if (fieldSet.has("debounce")) {
      t.debounce = this.debounce() !== null ? this.debounce()!.unpack() : null;
    }
    if (fieldSet.has("buffer")) {
      t.buffer = this.buffer() !== null ? this.buffer()!.unpack() : null;
    }
    if (fieldSet.has("connection")) {
      t.connection = this.connection() !== null ? this.connection()!.unpack() : null;
    }
    if (fieldSet.has("record_map")) {
      t.recordMap = this.recordMap() !== null ? this.recordMap()!.unpack() : null;
    }
    if (fieldSet.has("questdb")) {
      t.questdb = this.questdb() !== null ? this.questdb()!.unpack() : null;
    }
    if (fieldSet.has("frontend")) {
      t.frontend = this.frontend() !== null ? this.frontend()!.unpack() : null;
    }
    if (fieldSet.has("nyct")) {
      t.nyct = this.nyct() !== null ? this.nyct()!.unpack() : null;
    }
    if (fieldSet.has("payload_sample")) {
      t.payloadSample = this.bb!.createScalarList<number>(
        this.payloadSample.bind(this),
        this.payloadSampleLength(),
      );
    }
    if (fieldSet.has("extra")) {
      t.extra = this.bb!.createObjList<TraceKV, TraceKVT>(
        this.extra.bind(this),
        this.extraLength(),
      );
    }
    if (fieldSet.has("error_message")) {
      t.errorMessage = this.errorMessage();
    }
    return t;
  }
}

export class TraceEventT implements flatbuffers.IGeneratedObject {
  constructor(
    public correlationId: U128T | null = null,
    public sequenceNumber: bigint = 0n,
    public tracePoint: TracePointId = TracePointId.WvsListenerBound,
    public timestampNs: bigint = 0n,
    public outcome: TraceOutcome = TraceOutcome.Ok,
    public path: TracePath = TracePath.Forward,
    public source: SourceComponent = SourceComponent.Wvs,
    public bankId: U128T | null = null,
    public liftId: U128T | null = null,
    public fingerprint: MessageFingerprintT | null = null,
    public state: StateSnapshotT | null = null,
    public debounce: DebounceSnapshotT | null = null,
    public buffer: BufferSnapshotT | null = null,
    public connection: ConnectionSnapshotT | null = null,
    public recordMap: RecordMapSnapshotT | null = null,
    public questdb: QuestDbSnapshotT | null = null,
    public frontend: FrontendSnapshotT | null = null,
    public nyct: NyctSnapshotT | null = null,
    public payloadSample: number[] = [],
    public extra: TraceKVT[] = [],
    public errorMessage: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const correlationId = this.correlationId !== null ? this.correlationId!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const fingerprint = this.fingerprint !== null ? this.fingerprint!.pack(builder) : 0;
    const state = this.state !== null ? this.state!.pack(builder) : 0;
    const debounce = this.debounce !== null ? this.debounce!.pack(builder) : 0;
    const buffer = this.buffer !== null ? this.buffer!.pack(builder) : 0;
    const connection = this.connection !== null ? this.connection!.pack(builder) : 0;
    const recordMap = this.recordMap !== null ? this.recordMap!.pack(builder) : 0;
    const questdb = this.questdb !== null ? this.questdb!.pack(builder) : 0;
    const frontend = this.frontend !== null ? this.frontend!.pack(builder) : 0;
    const nyct = this.nyct !== null ? this.nyct!.pack(builder) : 0;
    const payloadSample = TraceEvent.createPayloadSampleVector(builder, this.payloadSample);
    const extra = TraceEvent.createExtraVector(builder, builder.createObjectOffsetList(this.extra));
    const errorMessage = this.errorMessage !== null ? builder.createString(this.errorMessage!) : 0;

    TraceEvent.startTraceEvent(builder);
    TraceEvent.addCorrelationId(builder, correlationId);
    TraceEvent.addSequenceNumber(builder, this.sequenceNumber);
    TraceEvent.addTracePoint(builder, this.tracePoint);
    TraceEvent.addTimestampNs(builder, this.timestampNs);
    TraceEvent.addOutcome(builder, this.outcome);
    TraceEvent.addPath(builder, this.path);
    TraceEvent.addSource(builder, this.source);
    TraceEvent.addBankId(builder, bankId);
    TraceEvent.addLiftId(builder, liftId);
    TraceEvent.addFingerprint(builder, fingerprint);
    TraceEvent.addState(builder, state);
    TraceEvent.addDebounce(builder, debounce);
    TraceEvent.addBuffer(builder, buffer);
    TraceEvent.addConnection(builder, connection);
    TraceEvent.addRecordMap(builder, recordMap);
    TraceEvent.addQuestdb(builder, questdb);
    TraceEvent.addFrontend(builder, frontend);
    TraceEvent.addNyct(builder, nyct);
    TraceEvent.addPayloadSample(builder, payloadSample);
    TraceEvent.addExtra(builder, extra);
    TraceEvent.addErrorMessage(builder, errorMessage);

    return TraceEvent.endTraceEvent(builder);
  }

  clone(): TraceEventT {
    const obj = new TraceEventT();
    obj.correlationId = this.correlationId !== null ? this.correlationId!.clone() : null;
    obj.sequenceNumber = this.sequenceNumber;
    obj.tracePoint = this.tracePoint;
    obj.timestampNs = this.timestampNs;
    obj.outcome = this.outcome;
    obj.path = this.path;
    obj.source = this.source;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.fingerprint = this.fingerprint !== null ? this.fingerprint!.clone() : null;
    obj.state = this.state !== null ? this.state!.clone() : null;
    obj.debounce = this.debounce !== null ? this.debounce!.clone() : null;
    obj.buffer = this.buffer !== null ? this.buffer!.clone() : null;
    obj.connection = this.connection !== null ? this.connection!.clone() : null;
    obj.recordMap = this.recordMap !== null ? this.recordMap!.clone() : null;
    obj.questdb = this.questdb !== null ? this.questdb!.clone() : null;
    obj.frontend = this.frontend !== null ? this.frontend!.clone() : null;
    obj.nyct = this.nyct !== null ? this.nyct!.clone() : null;
    obj.payloadSample = [...this.payloadSample];
    obj.extra = this.extra.map((e) => e.clone());
    obj.errorMessage = this.errorMessage;
    return obj;
  }

  equals(other: TraceEventT): boolean {
    if (this.correlationId !== null && other.correlationId !== null) {
      if (!this.correlationId!.equals(other.correlationId!)) return false;
    } else if (this.correlationId !== other.correlationId) return false;
    if (this.sequenceNumber !== other.sequenceNumber) return false;
    if (this.tracePoint !== other.tracePoint) return false;
    if (this.timestampNs !== other.timestampNs) return false;
    if (this.outcome !== other.outcome) return false;
    if (this.path !== other.path) return false;
    if (this.source !== other.source) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.fingerprint !== null && other.fingerprint !== null) {
      if (!this.fingerprint!.equals(other.fingerprint!)) return false;
    } else if (this.fingerprint !== other.fingerprint) return false;
    if (this.state !== null && other.state !== null) {
      if (!this.state!.equals(other.state!)) return false;
    } else if (this.state !== other.state) return false;
    if (this.debounce !== null && other.debounce !== null) {
      if (!this.debounce!.equals(other.debounce!)) return false;
    } else if (this.debounce !== other.debounce) return false;
    if (this.buffer !== null && other.buffer !== null) {
      if (!this.buffer!.equals(other.buffer!)) return false;
    } else if (this.buffer !== other.buffer) return false;
    if (this.connection !== null && other.connection !== null) {
      if (!this.connection!.equals(other.connection!)) return false;
    } else if (this.connection !== other.connection) return false;
    if (this.recordMap !== null && other.recordMap !== null) {
      if (!this.recordMap!.equals(other.recordMap!)) return false;
    } else if (this.recordMap !== other.recordMap) return false;
    if (this.questdb !== null && other.questdb !== null) {
      if (!this.questdb!.equals(other.questdb!)) return false;
    } else if (this.questdb !== other.questdb) return false;
    if (this.frontend !== null && other.frontend !== null) {
      if (!this.frontend!.equals(other.frontend!)) return false;
    } else if (this.frontend !== other.frontend) return false;
    if (this.nyct !== null && other.nyct !== null) {
      if (!this.nyct!.equals(other.nyct!)) return false;
    } else if (this.nyct !== other.nyct) return false;
    if (this.payloadSample.length !== other.payloadSample.length) return false;
    for (let i = 0; i < this.payloadSample.length; i++) {
      if (this.payloadSample[i] !== other.payloadSample[i]) return false;
    }
    if (this.extra.length !== other.extra.length) return false;
    for (let i = 0; i < this.extra.length; i++) {
      const a = this.extra[i];
      const b = other.extra[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.errorMessage !== other.errorMessage) return false;
    return true;
  }
}

export function verifyTraceEvent(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyU128(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 6, 8);
    verifier.checkScalarField(tablePos, 8, 2);
    verifier.checkScalarField(tablePos, 10, 8);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyU128(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 20);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyU128(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 22);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessageFingerprint(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 24);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyStateSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 26);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyDebounceSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 28);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBufferSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 30);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyConnectionSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 32);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyRecordMapSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 34);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyQuestDbSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 36);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyFrontendSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 38);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNyctSnapshot(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTraceKV);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
